<template>
    <div>
        <paid-modal v-if="show_modal" :redirect="true" @close="hideModal" />
        <div class="premium_icon" >
            <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.777064 1.04341L2.55721 2.56592L4.1432 0.667779C4.18761 0.614714 4.24376 0.572071 4.30748 0.543026C4.37119 0.513982 4.44083 0.499284 4.5112 0.500027C4.58157 0.50077 4.65087 0.516935 4.71392 0.547318C4.77697 0.577701 4.83216 0.621519 4.87537 0.67551L6.38885 2.56547L8.22653 1.02112C8.2987 0.960599 8.38816 0.922946 8.48295 0.913201C8.57774 0.903457 8.67332 0.922086 8.75692 0.966597C8.84051 1.01111 8.90813 1.07937 8.95071 1.16226C8.9933 1.24515 9.00882 1.3387 8.9952 1.4304L8.29344 6.13574H0.717648L0.00512243 1.45177C-0.00903114 1.35957 0.00631304 1.26536 0.0490766 1.18191C0.0918401 1.09846 0.159956 1.0298 0.2442 0.985237C0.328443 0.940671 0.424743 0.92235 0.520056 0.932754C0.615369 0.943159 0.705089 0.981786 0.777064 1.04341ZM0.75414 6.59049H8.23963V7.04525C8.23963 7.16585 8.19034 7.28152 8.10261 7.36681C8.01487 7.45209 7.89587 7.5 7.77179 7.5H1.22198C1.0979 7.5 0.978906 7.45209 0.891168 7.36681C0.80343 7.28152 0.75414 7.16585 0.75414 7.04525V6.59049Z"
                    fill="#FEF3C7" />
            </svg>
        </div>
    </div>
</template>

<script>
import PaidModal from "./PaidModal.vue";
export default {
    props: ['openModal'],
    components: {
        PaidModal
    },
    data() {
        return {
            show_modal: false
        }
    },
    mounted() {
        this.show_modal = this.openModal;
    },
    watch: {
        openModal(newVal) {
            this.show_modal = newVal;
        }
    },
    methods: {
        hideModal() {
            this.show_modal = false;
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
.premium_icon {
    background-color: #FBBF24;
    width: 21px;
    height: 21px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 5px;
}
</style>